export function clearConsole(delay) {
  if(delay)
    setInterval(() => {
      console.clear()
    }, delay)
  else
    console.clear()
}